/* eslint-disable @typescript-eslint/no-floating-promises */
import i18n, { InitOptions, LanguageDetectorAsyncModule, Services } from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./assets/locales/en/translation.json";
import translationFR from "./assets/locales/fr/translation.json";

// Define the custom language detector
// https://www.i18next.com/misc/creating-own-plugins#languagedetector
// Above one is not very readable, below is an example of the newest approach
// https://gist.github.com/naishe/a6d9ea9d23214875ac176b63387ab833
const languageDetectorVerity: LanguageDetectorAsyncModule = {
	type: "languageDetector",
	// If this is set to true, your detect function receives a callback function that you should call with your language,
	//useful to retrieve your language stored in AsyncStorage for example
	async: true,
	init: (_services: Services, _detectorOptions: object, _i18nextOptions: InitOptions) => {
		/* use services and options */
		// We can do something like "services.logger" here, but not needed
	},
	detect: (callback) => {
		// First, try to detect the language from the query string
		// The i18next original queryString code is:
		// https://github.com/i18next/i18next-browser-languageDetector/blob/master/src/browserLookups/querystring.js
		// const queryString = window.location.search;
		// const urlParams = new URLSearchParams(queryString);
		// const languageFromQueryString = urlParams.get("lng");

		// If we have a language from the query string, we'll use it
		// if (languageFromQueryString) {
		// 	callback(languageFromQueryString);
		// 	return; // Exit the function after callback
		// }

		// If not, we try to get the language from the state management system
		callback("en");
	},
};

export const resources = {
	en: {
		translation: translationEN,
	},
	fr: {
		translation: translationFR,
	},
};

i18n
	// Use the custom language detector
	.use(languageDetectorVerity)
	// Pass the i18n instance to react-i18next.
	.use(initReactI18next)
	.init({
		// directly import the resources(or it can be done through i18next-backend packages)
		resources,
		fallbackLng: "en",
		// Since we are using a custom detector, we won't configure 'detection' option here
		interpolation: {
			escapeValue: false, // React already safes from XSS
		},
		// Add other i18next options if needed
	});

export default i18n;
